export const ufiInformaticosDenunciaConfig = [
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial",
    pathName: "ufi-informatica-denuncia",
    titulo: "UFI - DELITOS INFORMÁTICOS Y ESTAFAS POR DENUNCIA",
    icon: "pi-building",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI",
    props: {
      formType: "ufi-estafas-y-delitos-informaticos",
      actuacionType: "ufi-informatica-denuncia",
    },
    nameOfRoute: "actuacion-initial",
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial/denunciante",
    pathName: "ufi-informatica-denuncia",
    titulo: "AFECTADOS",
    nameOfRoute: "actuacion-form-denunciante",
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial/momento",
    pathName: "ufi-informatica-denuncia",
    titulo: "FECHA, HORA y UBICACIÓN",
    nameOfRoute: "actuacion-form-momento",
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial/acusado",
    pathName: "ufi-informatica-denuncia",
    titulo: "VINCULADOS",
    nameOfRoute: "actuacion-form-acusado",
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial/efectos",
    pathName: "ufi-informatica-denuncia",
    titulo: "EFECTOS",
    nameOfRoute: "actuacion-form-efectos",
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial/patrimonialAffectation",
    pathName: "ufi-informatica-denuncia",
    titulo: "AFECTACIÓN PATRIMONIAL",
    nameOfRoute: "actuacion-form-patrimonialAffectation",
  },
];
